/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemAggregationSpecSchema } from './itemAggregationSpecSchema';

export const itemAggregationRequestSchema = z.object({
  get aggregations() {
    return z.array(itemAggregationSpecSchema).min(1);
  },
  ids: z.array(z.int()).min(1),
});
